import getApi from '../../api'
import { PrescriptionTemplate } from '../../model/PrescriptionTemplate'

export const createPrescriptionTemplate = (prescriptionUuid: string, name: string) =>
  getApi().post<PrescriptionTemplate>('/prescription_templates/create_from_prescription', {
    prescriptionUuid,
    name,
  })
